<template>
  <div>
    <div id="tic">
      <div>
        <div style="display:inline-block">
          <el-input v-model="para.searchKey" placeholder="请输入销售合同号" @change="(value) => {return handleSearch(0, value)}" clearable></el-input>
        </div>
        <el-select v-model="para.orderStatus" placeholder="订单状态(所有)" @change="(value) => {return handleSearch(1, value)}" clearable>
          <el-option
            v-for="n in orderStatusList"
            :key="n.key"
            :label="n.name"
            :value="n.id">
          </el-option>
        </el-select>
      </div>
  </div>
    <!-- 列表 -->

      <template>
        <el-table
          :data="list"
          style="width: 100%">

          <el-table-column
            label="销售合同号">
            <template slot-scope="scope">
              <div>{{ scope.row.contractNumber }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="商品名称">
            <template slot-scope="scope">
              <div>{{ scope.row.goodsName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="型号">
            <template slot-scope="scope">
              <div>{{ scope.row.model }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="客户名称">
            <template slot-scope="scope">
              <div>{{ scope.row.companyName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="收款日期">
            <template slot-scope="scope">
              <div>{{ formatime(scope.row.signTime) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="付款方式">
            <template slot-scope="scope">
              <div>{{ checkStatus('paymentType', scope.row.paymentType) }}</div>
            </template>
          </el-table-column>

           <el-table-column
            label="状态">
            <template slot-scope="scope">
              <div>{{ checkStatus('orderStatus', scope.row.orderStatus) }}</div>
            </template>
          </el-table-column>
          
          <el-table-column
            width="320"
            label="操作选项">
            <template slot-scope="scope">
              <!-- orderStatus: '', //   {
                  id: 10,
                  name: '已收款'
                },
                {
                  id: 8,
                  name: '未收款'
                },
                {
                  id: 9,
                  name: '部分收款'
                },
                {
                  id: 6,
                  name: '待开票' -->
              <el-button
                size="mini"
                type="info"
                @click="handleSet('query', scope.row)">查看</el-button>
                 <!-- query.查看, edit.编辑, get.收款, ticket.开票 -->
              <el-button
                size="mini"
                type="primary"
                v-if="(scope.row.orderStatus === 8)"
                @click="handleSet('edit', scope.row)">编辑</el-button>

              <el-button
                size="mini"
                type="warning"
                v-if="scope.row.orderStatus === 10 || scope.row.orderStatus === 9 "
                @click="handleSet('edit2', scope.row)">编辑</el-button>
<!--               
              <el-button
                size="mini"
                v-if="scope.row.orderStatus === 9 || scope.row.orderStatus === 8"
                @click="handleSet('get', scope.row)">收款</el-button>

              <el-button
                size="mini"
                v-if="scope.row.orderStatus === 6"
                @click="handleSet('ticket', scope.row)">开票</el-button> -->
            
            </template>
          </el-table-column>
        </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch(5, value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>

    <!-- 弹框 -->
    <el-dialog
        :title="dialogPara.title"
        :visible.sync="dialogPara.isShowDialog"
        width="50%"
        center>
        <!-- 内容 -->
        <el-form :model="form" :rules="dialogPara.rules">

          <!-- 查看 -->
          <div  v-if="currentStatus === 'query'">
            <div class="disflexbtw">
              <el-form-item label="销售合同号">
                {{ form.contractNumber? form.contractNumber: '' }}
              </el-form-item>

              <el-form-item label="商品名称">
                {{ form.goodsName }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="商品型号">
                {{ form.model }}
              </el-form-item>

              <!-- <el-form-item label="规格">
                {{ form.packWeight + form.goodsSpec }}
              </el-form-item> -->
            </div>

            <div class="disflexbtw">
              <el-form-item label="客户名称">
                {{ form.company.chineseName }}
              </el-form-item>

              <el-form-item label="付款方式">
                {{ checkStatus('paymentType', form.paymentType) }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="信用代码证">
                {{ form.company.creditCodeCertificate }}
              </el-form-item>

              <el-form-item label="开户行">
                {{ form.company.openingBank }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="银行账号">
                {{ form.company.bankAccount }}
              </el-form-item>

              <el-form-item label="客户实收">
                {{ form.realQuantity }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售数量(净重)">
                {{ form.salesQuantity }}
              </el-form-item>

              <el-form-item label="收货日期">
                {{ formatime(form.signTime) }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售单价">
                {{ form.unitCost }}
              </el-form-item>

              <el-form-item label="销售总价">
                {{ form.totalPrices }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售合同">
                <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
              </el-form-item>
            </div>
            <!-- 开票后方可查看 -->
            <div v-if="form.invoiceVo">
              <div class="disflexbtw">
                <el-form-item label="开票日期">
                  {{ formatime(form.invoiceVo.invoiceTime) }}
                </el-form-item>

                <el-form-item label="开票金额">
                  {{ form.invoiceVo.invoiceMoney }}
                </el-form-item>
              </div>
                
              
              <div  v-for="(n) in form.invoiceVo.invoiceCollects" :key="n.keys">

                <div class="disflexbtw">
                  <el-form-item label="发票号">
                    {{ n.invoiceNumber }}
                  </el-form-item>

                  <el-form-item label="发票扫描件">
                    <el-button  type="primary" size="mini" @click="downloadpdf(n.invoiceUrl)" >预览下载</el-button>
                  </el-form-item>
                </div>
              </div>

              <div class="disflexbtw">
                <el-form-item label="顺丰单号">
                  {{ form.invoiceVo.expressNumber }}
                </el-form-item>

                <el-form-item label="发票收件地址">
                  {{ form.invoiceVo.invoiceAddress }}
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票收件人">
                  {{ form.invoiceVo.nvoiceRecipientsName }}
                </el-form-item>

                <el-form-item label="发票收件电话">
                  {{ form.invoiceVo.phone }}
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票票种">
                  {{ form.invoiceVo.invoiceType }}
                </el-form-item>

                <el-form-item label="发票税率">
                  {{ form.invoiceVo.invoiceTaxRate }}
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票快递费">
                  {{ form.invoiceVo.postage }}
                </el-form-item>
              </div>
            </div><!-- 开票后方可查看 -->

            <!-- 预收款状态可查看 -->
            <div v-if="form.receiptMoney">

              <div v-if="form.paymentType === 3">
                <div class="disflexbtw">
                  <el-form-item label="预收款日期">
                    {{ formatime(form.receiptMoney.advancesReceivedDate) }}
                  </el-form-item>

                  <el-form-item label="预收款金额">
                    {{ form.receiptMoney.advancesReceivedMoney }}
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="尾款支付预计时间">
                    {{ formatime(form.receiptMoney.receiptBalancePaymentDate) }}
                  </el-form-item>

                  <el-form-item label="尾款金额">
                    {{ form.receiptMoney.balancePaymentMoney }}
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="实际支付尾款时间">
                    {{ formatime(form.receiptMoney.balancePaymentMoneyDate) }}
                  </el-form-item>
                </div>
              </div>

              <div class="disflexbtw" v-if="(form.paymentType === 1 || form.paymentType === 2)">
                <el-form-item label="收款日期">
                  {{ formatime(form.receiptMoney.receiptData) }}
                </el-form-item>

                <el-form-item label="收款金额">
                  {{ form.receiptMoney.officialReceiptsMoney }}
                </el-form-item>
              </div>
            </div><!-- 预收款状态可查看 -->
            
          </div><!-- 查看结束 -->


           <!-- 开票 -->
          <div v-if="currentStatus === 'ticket'">

              <div class="disflexbtw">
                <el-form-item label="开票日期">
                  <el-date-picker
                    v-model="form.invoiceVo.invoiceTime"
                    type="date"
                    placeholder="开票日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="开票金额">
                  <el-input v-model="form.invoiceVo.invoiceMoney" ></el-input>
                </el-form-item>
              </div>
                
              
              <div  v-for="(n, index) in form.invoiceVo.invoiceCollects" :key="n.keys">

                <div class="disflexbtw">
                  <el-form-item :label="'发票号' + parseInt(index+1)">
                    <el-input v-model="n.invoiceNumber" placeholder="发票号"></el-input>
                  </el-form-item>

                  <el-form-item :label="'发票扫描件' + parseInt(index+1)">
                    <el-upload
                      class="avatar-uploader"
                      :data="qiniu"
                      action="https://upload.qiniup.com"
                      :show-file-list="false"
                      :multiple="false"
                      :before-upload="(file) => {return handleBeforeUpload(file, index)}"
                      :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, index) }"
                    >
                      <img v-if="form.invoiceVo.invoiceCollects[index].invoiceUrl" :src="form.invoiceVo.invoiceCollects[index].invoiceUrl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                  <div>
                    <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
                  </div>
                </div>
              </div>
              
              <div style="display:flex;justify-content: flex-end">
                <el-form-item >
                  <el-button @click="addDom()">新增参数</el-button>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="顺丰单号">
                  <el-input v-model="form.invoiceVo.expressNumber" ></el-input>
                </el-form-item>

                <el-form-item label="发票收件地址">
                   <el-select v-model="form.invoiceVo.invoiceLocationId" placeholder="请选择">
                    <el-option
                      v-for="item in addressList"
                      :key="item.key"
                      :label="item.address"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票收件人">
                  <el-select v-model="form.invoiceVo.invoiceRecipientsId" placeholder="请选择">
                    <el-option
                      v-for="item in contacts"
                      :key="item.key"
                      :label="item.name + ' : ' + item.phone"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票票种">
                  <el-select v-model="form.invoiceVo.invoiceTypeId" placeholder="请选择">
                    <el-option
                      v-for="item in dictionaryData1"
                      :key="item.key"
                      :label="item.dictDataName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票税率">
                  <el-select v-model="form.invoiceVo.invoiceTaxRateId" placeholder="请选择">
                    <el-option
                      v-for="item in dictionaryData2"
                      :key="item.key"
                      :label="item.dictDataName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票快递费">
                  <el-input v-model="form.invoiceVo.postage" ></el-input>
                </el-form-item>
              </div>

          </div><!-- 开票结束 -->



          <!-- 未收款 -->
          <div v-if="currentStatus === 'get'">
            <!-- 预收部分货款 -->
            <div v-if="form.paymentType === 3">
              <div class="disflexbtw">
                <el-form-item label="预收款日期">
                  <el-date-picker
                    v-model="form.advancesReceivedDate"
                    type="date"
                    placeholder="预收款日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="预收款金额">
                  <el-input v-model="form.advancesReceivedMoney" ></el-input>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="尾款支付预计时间">
                  <el-date-picker
                    v-model="form.receiptBalancePaymentDate"
                    type="date"
                    placeholder="尾款支付预计时间">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="尾款金额">
                  <el-input v-model="form.balancePaymentMoney" ></el-input>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="实际支付尾款时间">
                  <el-date-picker
                    v-model="form.balancePaymentMoneyDate"
                    type="date"
                    placeholder="实际支付尾款时间">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>

            <!-- 货到付款 -->
            <div class="disflexbtw" v-if="form.paymentType === 1 || form.paymentType === 2">
              <el-form-item label="收款日期">
                <el-date-picker 
                  v-model="form.receiptData"
                  type="date"
                  
                  placeholder="收款日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="收款金额">
                <el-input v-model="form.officialReceiptsMoney" ></el-input>
              </el-form-item>
            </div>

          </div><!-- 未收款结束 -->



         <!-- 编辑 -->
          <div  v-if="currentStatus === 'edit'">
            <div class="disflexbtw">
              <el-form-item label="销售合同号">
                {{ form.contractNumber }}
              </el-form-item>

              <el-form-item label="商品名称">
                {{ form.goodsName }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="商品型号">
                {{ form.model }}
              </el-form-item>

              <!-- <el-form-item label="规格">
                {{ form.packWeight + form.goodsSpec }}
              </el-form-item> -->
            </div>

            <div v-if="form.company">
              <div class="disflexbtw">
                <el-form-item label="客户名称">
                  {{ form.company.chineseName }}
                </el-form-item>

                <el-form-item label="付款方式">
                  {{ checkStatus('paymentType', form.paymentType) }}
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="信用代码证">
                  {{ form.company.creditCodeCertificate }}
                </el-form-item>

                <el-form-item label="开户行">
                  {{ form.company.openingBank }}
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="银行账号">
                  {{ form.company.bankAccount }}
                </el-form-item>
              </div>
            </div>


             <div class="disflexbtw">
              <el-form-item label="客户实收">
                {{ form.realQuantity }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售数量(净重)">
                {{ form.salesQuantity }}
              </el-form-item>

              <el-form-item label="收货日期">
                {{ form.deliveryTime }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售单价">
                {{ form.unitCost }}
              </el-form-item>

              <el-form-item label="销售总价">
                {{ form.totalPrices }}
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="销售合同">
                <el-button type="primary" size="mini" @click="downloadpdf(form.salesContractUrl)" >预览下载</el-button>
              </el-form-item>
            </div>
            <!-- 开票后方可查看 -->
            <div v-if="form.invoiceVo">
               <div class="disflexbtw">
                <el-form-item label="开票日期">
                  <el-date-picker
                    v-model="form.invoiceVo.invoiceTime"
                    type="date"
                    placeholder="开票日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="开票金额">
                  <el-input v-model="form.invoiceVo.invoiceMoney" ></el-input>
                </el-form-item>
              </div>
                
              
              <div  v-for="(n, index) in form.invoiceVo.invoiceCollects" :key="n.keys">

                <div class="disflexbtw">
                  <el-form-item :label="'发票号' + parseInt(index+1)">
                    <el-input v-model="n.invoiceNumber" placeholder="发票号"></el-input>
                  </el-form-item>

                  <el-form-item :label="'发票扫描件' + parseInt(index+1)">
                    <el-upload
                      class="avatar-uploader"
                      :data="qiniu"
                      action="https://upload.qiniup.com"
                      :show-file-list="false"
                      :multiple="false"
                      :before-upload="(file) => {return handleBeforeUpload(file, index)}"
                      :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, index) }"
                    >
                      <img v-if="form.invoiceVo.invoiceCollects[index].invoiceUrl" :src="form.invoiceVo.invoiceCollects[index].invoiceUrl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                  <div>
                    <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
                  </div>
                </div>
              </div>
              
              <div style="display:flex;justify-content: flex-end">
                <el-form-item >
                  <el-button @click="addDom()">新增参数</el-button>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="顺丰单号">
                  <el-input v-model="form.invoiceVo.expressNumber" ></el-input>
                </el-form-item>

                <el-form-item label="发票收件地址">
                   <el-select v-model="form.invoiceVo.invoiceLocationId" placeholder="请选择">
                    <el-option
                      v-for="item in addressList"
                      :key="item.key"
                      :label="item.address"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票收件人">
                  <el-select v-model="form.invoiceVo.invoiceRecipientsId" placeholder="请选择">
                    <el-option
                      v-for="item in contacts"
                      :key="item.key"
                      :label="item.name + ' : ' + item.phone"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票票种">
                  <el-select v-model="form.invoiceVo.invoiceTypeId" placeholder="请选择">
                    <el-option
                      v-for="item in dictionaryData1"
                      :key="item.key"
                      :label="item.dictDataName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="发票税率">
                  <el-select v-model="form.invoiceVo.invoiceTaxRateId" placeholder="请选择">
                    <el-option
                      v-for="item in dictionaryData2"
                      :key="item.key"
                      :label="item.dictDataName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="disflexbtw">
                <el-form-item label="发票快递费">
                  <el-input v-model="form.invoiceVo.postage" ></el-input>
                </el-form-item>
              </div>
            </div><!-- 开票后方可查看 -->

            <!-- 预收款状态可查看 -->
            <div v-if="form.receiptMoney">
              <div v-if="currentStatus === 'edit2' && (form.paymentType === 3)">
                <div class="disflexbtw">
                  <el-form-item label="预收款日期">
                    <el-date-picker
                      v-model="form.receiptMoney.advancesReceivedDate"
                      type="date"
                      placeholder="预收款日期">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="预收款金额">
                    <el-input v-model="form.receiptMoney.advancesReceivedMoney" ></el-input>
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="尾款支付预计时间">
                    <el-date-picker
                      v-model="form.receiptMoney.receiptBalancePaymentDate"
                      type="date"
                      placeholder="尾款支付预计时间">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="尾款金额">
                    <el-input v-model="form.receiptMoney.balancePaymentMoney" ></el-input>
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="实际支付尾款时间">
                    <el-date-picker
                      v-model="form.receiptMoney.balancePaymentMoneyDate"
                      type="date"
                      placeholder="实际支付尾款时间">
                    </el-date-picker>
                  </el-form-item>
                </div>
              </div>

              <!-- 货到付款 -->
              <div class="disflexbtw" v-if="(form.paymentType === 1 || form.paymentType === 2)">
                <el-form-item label="收款日期">
                  <el-date-picker 
                    v-model="form.receiptMoney.receiptData"
                    type="date"
                    
                    placeholder="收款日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="收款金额">
                  <el-input v-model="form.receiptMoney.officialReceiptsMoney" ></el-input>
                </el-form-item>
              </div>
              
            </div><!-- 预收款状态可查看 -->
            
          </div><!-- 编辑结束 -->

          <!-- 货到付款已收款编辑 -->
          <div class="disflexbtw" v-if="currentStatus === 'edit2' && form.receiptMoney">

            <div v-if="(form.paymentType === 1 || form.paymentType === 2)">
              <el-form-item label="收款日期">
                <el-date-picker
                  v-model="form.receiptMoney.receiptData"
                  type="date"
                  placeholder="收款日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="收款金额">
                <el-input v-model="form.receiptMoney.officialReceiptsMoney" ></el-input>
              </el-form-item>
            </div>

            <div v-if="form.paymentType === 3">
                <div class="disflexbtw">
                  <el-form-item label="预收款日期">
                    <el-date-picker
                      v-model="form.receiptMoney.advancesReceivedDate"
                      type="date"
                      placeholder="预收款日期">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="预收款金额">
                    <el-input v-model="form.receiptMoney.advancesReceivedMoney" ></el-input>
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="尾款支付预计时间">
                    <el-date-picker
                      v-model="form.receiptMoney.receiptBalancePaymentDate"
                      type="date"
                      placeholder="尾款支付预计时间">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="尾款金额">
                    <el-input v-model="form.receiptMoney.balancePaymentMoney" ></el-input>
                  </el-form-item>
                </div>

                <div class="disflexbtw">
                  <el-form-item label="实际支付尾款时间">
                    <el-date-picker
                      v-model="form.receiptMoney.balancePaymentMoneyDate"
                      type="date"
                      placeholder="实际支付尾款时间">
                    </el-date-picker>
                  </el-form-item>
                </div>
            </div>

          </div><!-- 编辑结束 -->

          <!-- 开票后方可查看 -->
          <div v-if="currentStatus === 12">
            
            <div class="disflexbtw">
              <el-form-item label="开票日期">
                <el-date-picker
                  v-model="form.invoiceVo.invoiceTime"
                  type="date"
                  
                  placeholder="开票日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="开票金额">
                <el-input v-model="form.invoiceVo.invoiceMoney" ></el-input>
              </el-form-item>
            </div>
              
            <div  v-for="(n, index) in form.invoiceVo.invoiceCollects" :key="n.keys">

              <div class="disflexbtw">
                <el-form-item :label="'发票号' + parseInt(index+1)">
                  <el-input v-model="n.invoiceNumber" placeholder="发票号"></el-input>
                </el-form-item>

                <el-form-item :label="'发票扫描件' + parseInt(index+1)">
                  <el-upload
                    class="avatar-uploader"
                    :data="qiniu"
                    action="https://upload.qiniup.com"
                    :show-file-list="false"
                    :multiple="false"
                    :before-upload="(file) => {return handleBeforeUpload(file, index)}"
                    :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, index) }"
                  >
                    <img v-if="form.invoiceVo.invoiceCollects[index].invoiceUrl" :src="form.invoiceVo.invoiceCollects[index].invoiceUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <div>
                  <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
                </div>
              </div>
            </div>
            
            <div style="display:flex;justify-content: flex-end">
              <el-form-item >
                <el-button @click="addDom()">新增参数</el-button>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="顺丰单号">
                <el-input v-model="form.invoiceVo.expressNumber" ></el-input>
              </el-form-item>

              <el-form-item label="发票收件地址">
                <el-input v-model="form.invoiceVo.invoiceAddress" ></el-input>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="发票收件人">
                <el-input v-model="form.invoiceVo.nvoiceRecipientsName" ></el-input>
              </el-form-item>

              <el-form-item label="发票收件电话">
                <el-input v-model="form.invoiceVo.invoiceAddress" ></el-input>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="发票票种">
                <el-input v-model="form.invoiceVo.invoiceType" ></el-input>
              </el-form-item>

              <el-form-item label="发票税率">
                <el-input v-model="form.invoiceVo.invoiceTaxRate" ></el-input>
              </el-form-item>
            </div>
            <div class="disflexbtw">
              <el-form-item label="发票快递费">
                <el-input v-model="form.invoiceVo.postage" ></el-input>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="预收款日期">
                <el-date-picker
                  v-model="form.advancesReceivedDate"
                  type="date"
                  
                  placeholder="预收款日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="预收款金额">
                <el-input v-model="form.advancesReceivedMoney" ></el-input>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="尾款支付预计时间">
                <el-date-picker
                  v-model="form.receiptBalancePaymentDate"
                  type="date"
                  
                  placeholder="尾款支付预计时间">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="尾款金额">
                <el-input v-model="form.balancePaymentMoney" ></el-input>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="实际支付尾款时间">
                <el-date-picker
                  v-model="form.balancePaymentMoneyDate"
                  type="date"
                  
                  placeholder="实际支付尾款时间">
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="disflexbtw">
              <el-form-item label="收款日期">
                <el-date-picker
                  v-model="form.receiptData"
                  type="date"
                  
                  placeholder="收款日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="收款金额">
                <el-input v-model="form.officialReceiptsMoney" ></el-input>
              </el-form-item>
            </div>
          </div><!-- 开票结束 -->

        </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
    </el-dialog>
   
  </div>
</template>

<script>
//  收款列表, 七牛上载, 七牛下载,
//  收款详情, 地址, 联系人
//  开票类型, 收款, 开票,
//  开票修改
import { 
  orderqueryByInvoiceLaterList, qiniuupload, qiniugetDown,
  orderqueryInvoiceAndReceipt, addressfindByCompanyId, queryByCompanyId,
  dictionariesqueryDictionaryData, orderreceiptMoney, ordermakeOutInvoice,
  orderupdateInvoiceAndReceipt
 } from '../../api'
import utils from '../../../public/utils'
import moment from 'moment'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      orderStatusList: [ //  订单状态
        {
          id: 10,
          name: '已收款'
        },
        {
          id: 8,
          name: '未收款'
        },
        {
          id: 9,
          name: '部分收款'
        },
        {
          id: 6,
          name: '待开票'
        },
      ],
      paymentTypeList: [ //  1.货到付款，2.款到发货 3，预售部分货款'
        {
          id: 1,
          name: '货到付款',
        },
        {
          id: 2,
          name: '款到发货',
        },
        {
          id: 3,
          name: '预售部分货款',
        },
      ],
      para: { //  查询条件
        searchKey: '', //  订单编号
        orderStatus: '', //  订单状态
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      total: 0,
      currentStatus: '', //  当前操作状态
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
      },
      form: {
        company: {},
        invoiceVo: {
          invoiceTime: '',
          invoiceCollects: []
        },
      },
      fileList: {
        salesContractUrl: [], //  销售合同
      },
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      uploadUrl: '', //  上传地址前缀
      addressList: [], //  地址
      contacts: [], //  联系人
      dictionaryData1: [], //  发票类型
      dictionaryData2: [], //  税率类型
      payType: '', //  当前付款方式
      tickets: {}, //  开票参数
      orderId: '',
    }
  },
  mounted () {
    this.getorderqueryByInvoiceLaterList()
    this.getToken()
  },
  methods: {
    handleSearch (type, val) { //  0.合同号, 1.处理方式, 2.订单状态, 5.分页
      console.log(type, val)
      switch(type) {
        case 5:
          this.para.pageIndex = val
          break
        case 2:
          this.para.orderStatus = val
      }
      this.getorderqueryByInvoiceLaterList()
    },
    handleSet (type, val) { // query.查看, edit.编辑, get.收款, ticket.开票
      console.log(type, val)
      this.dialogPara.isShowDialog = true
      this.currentStatus = type //  设置当前操作状态
      switch (type) {
        case 'query':
          this.dialogPara.title = '查看详情'
          this.getorderqueryInvoiceAndReceipt(val.id)
          break
        case 'ticket':
          this.dialogPara.title = '开票'
          this.getaddressfindByCompanyId(val.companyId)
          this.getqueryByCompanyId(val.companyId)
          this.getdictionariesqueryDictionaryData(1)
          this.getdictionariesqueryDictionaryData(2)
          this.form = {
            id: val.id,
            company: {},
            invoiceVo: {
              invoiceTime: '',
              invoiceCollects: [
                {
                  invoiceNumber: '',
                  invoiceUrl: ''
                }
              ]
            }
          }
          break
        case 'get':
          this.dialogPara.title = '收款'
          this.payType = val.paymentType
          this.orderId = val.id
          this.form = {}
          break
        case 'edit':
          this.getaddressfindByCompanyId(val.companyId) //  公司地址
          this.getqueryByCompanyId(val.companyId) //  联系人
          this.getdictionariesqueryDictionaryData(1)
          this.getdictionariesqueryDictionaryData(2)
          this.getorderqueryInvoiceAndReceipt(val.id)
          break
        case 'edit2':
          this.dialogPara.title = '编辑'
          this.getorderqueryInvoiceAndReceipt(val.id)
          break
      }
    },
    handleSucess () { // query.查看, edit.编辑, get.收款, ticket.开票
      console.log(this.form)
      switch (this.currentStatus) {
        case 'query':
          this.dialogPara.isShowDialog = false
          break
        case 'edit':
          this.postorderupdateInvoiceAndReceipt()
          break
        case 'edit2':
          this.postorderupdateInvoiceAndReceipt()
          break
        case 'get':
          this.postorderreceiptMoney()
          break
        case 'ticket':
          this.postordermakeOutInvoice()
          break
      }
    },
    handleBeforeUpload (file, type) { //  上传之前
      console.log(file, type)
      this.qiniu.key = ``+ type +`${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, type) { //  上传成功之后
      console.log(type)
      if (typeof(type) === 'number') {
        this.form.invoiceVo.invoiceCollects[type].invoiceUrl = this.uploadUrl + response.key
      } else {
        this.form[type] =  this.qiniu.uploadUrl + response.key
        this.fileList[type].push({ //  显示文件
          name: response.key,
          url: this.qiniu.uploadUrl + response.key
        })
      }
    },
    handleOnRemove (file, fileList, type) { //  删除
      this.fileList[type] = []
      console.log(file, fileList)
    },
    removeDom (item) { //  删除元素
    // form.invoiceVo.invoiceCollects[index].invoiceUrl
      let dom = this.form.invoiceVo.invoiceCollects
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    addDom () { //  增加参数
      this.form.invoiceVo.invoiceCollects.push({
        invoiceNumber: '', //  发票号
        invoiceUrl: '', //  发票url
      })
    },
    postorderupdateInvoiceAndReceipt () { //  编辑
      console.log(this.form)

      // this.form.invoiceVo.invoiceTime = this.formatime(this.form.invoiceVo.invoiceTime)
      this.form.invoiceVo = JSON.stringify(this.form.invoiceVo)
      this.form.receiptMoney?this.form.receiptMoney = JSON.stringify(this.form.receiptMoney):null
      // this.form.receiptMoney = JSON.stringify(this.form.receiptMoney)
      this.form.orderId = this.form.id
      let para = new URLSearchParams(this.form)
      orderupdateInvoiceAndReceipt(para).then(data => {
        console.log(data)
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryByInvoiceLaterList() //  查询列表
          this.dialogPara.isShowDialog = false //  关闭弹出框
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    postorderreceiptMoney () { //  收款
      console.log(this.form)
      this.form.orderId = this.orderId
      if (this.payType === 1 || this.paymentType === 2) {
        this.form.receiptData = this.formatime(this.form.receiptData)
      } else {
        this.form.advancesReceivedDate = this.formatime(this.form.advancesReceivedDate)
        this.form.receiptBalancePaymentDate = this.formatime(this.form.receiptBalancePaymentDate)
        this.form.balancePaymentMoneyDate = this.formatime(this.form.balancePaymentMoneyDate)
       }
      let para = new URLSearchParams(this.form)
      orderreceiptMoney(para).then(data => {
        console.log(data)
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryByInvoiceLaterList() //  查询列表
          this.dialogPara.isShowDialog = false //  关闭弹出框
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    postordermakeOutInvoice () { //  开票
      console.log(this.form)
      let a = {}
      this.form.invoiceVo.invoiceCollects.forEach(item =>{
        a[item.invoiceUrl] = item.invoiceNumber
      })
      console.log(a)
      let paras = {
        orderId: this.form.id,
        invoiceTime: this.formatime(this.form.invoiceVo.invoiceTime), //  开票时间
        invoiceMoney: this.form.invoiceVo.invoiceMoney, //  开票金额
        invoiceMap: JSON.stringify(a), //  发票号
        expressNumber: this.form.invoiceVo.expressNumber, //  顺丰单号
        invoiceLocationId: this.form.invoiceVo.invoiceLocationId, //  收件人地址
        invoiceRecipientsId: this.form.invoiceVo.invoiceRecipientsId, //  收件人
        invoiceTypeId: this.form.invoiceVo.invoiceTypeId, //  发票类型
        invoiceTaxRateId: this.form.invoiceVo.invoiceTaxRateId, //  税率
        postage: this.form.invoiceVo.postage //  邮费
      }
      console.log(paras)
      let para = new URLSearchParams(paras)
      ordermakeOutInvoice(para).then(data => {
        console.log(data)
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getorderqueryByInvoiceLaterList() //  查询列表
          this.dialogPara.isShowDialog = false //  关闭弹出框
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
        
      })
    },
    getqueryByCompanyId (val) { //  根据公司id查询联系人列表
      console.log(val)
      let para = {
        id: val
      }
      queryByCompanyId(para).then(data => {
        console.log(data)
        this.contacts = data.data.data
      })
    },
    getaddressfindByCompanyId (row) { //  收件地址
      console.log(row)
      let para = {
        companyId: row
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.addressList = data.data.data //  收件地址
      })
    },
    getorderqueryByInvoiceLaterList () { //  查询列表
      let para = new URLSearchParams(this.para)
      orderqueryByInvoiceLaterList(para).then(data => {
        console.log(data)
        this.list = data.data.rows
        this.total = data.data.total
      })
    },
    getdictionariesqueryDictionaryData (val) { //  获取开票或税率
      let paras = {
        dictionaryId: val
      }
      let para = new URLSearchParams(paras)
      dictionariesqueryDictionaryData(para).then(data => {
        console.log(data)
        switch (val) {
          case 1:
            this.dictionaryData1 = data.data
            break
          case 2:
            this.dictionaryData2 = data.data
            break
        }
      })
    },
    getorderqueryInvoiceAndReceipt (id) { //  收款详情
      let p = {
        orderId: id
      }
      let para = new URLSearchParams(p)
      orderqueryInvoiceAndReceipt(para).then(data => {
        
        console.log(data)
        this.form = data.data
        console.log(this.form)
        if (this.form.invoiceVo) {
          // this.getaddressfindByCompanyId(this.form.invoiceVo.invoiceLocationId) //  , '发票收件地址')
          // this.getqueryByCompanyId(this.form.invoiceVo.invoiceRecipientsId) //  , '发票收件人')
        }
        // this.getdictionariesqueryDictionaryData(this.form.invoiceVo.invoiceTypeId) //  , '发票票种')
        // this.getdictionariesqueryDictionaryData(this.form.invoiceVo.invoiceTaxRateId) //  , '发票税率')
      })
    },
    handleChange(value, type) {
      console.log(value)
      switch (type) {
        case '发票收件地址':
          this.getaddressfindByCompanyId(value) //  调用收件地址接口
          break
        case '发票收件人':
          this.getqueryByCompanyId(value) //  收件人
          break
        case '发票票种':
          this.getdictionariesqueryDictionaryData(value) //  票种
          break
        case '发票税率':
          this.getdictionariesqueryDictionaryData(value) //  税率
          break
      }
    },
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-sea-transportation')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    downloadpdf (w) { // 下载
      console.log(w)
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data)
        window.open(data.data)
      })
    },
    checkStatus (type, val) {  //  状态
      // console.log(type, val)
      let res
      switch (type) { //  
        case 'paymentType': //  付款方式
          res = utils.paymentType(val)
          return res
        case 'orderStatus': //  订单状态
          res = utils.orderStatus(val)
          return res
      }
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  }
}
</script>

<style lang="stylus" >
#tic
  display flex
  justify-content space-between
  // .comond_btn
  //   display flex
  //   justify-content flex-end
  //   margin-bottom 30px
  //   button
  //     background-color #0a3d5f
  //     color #fff
.el-form-item
  display flex
.forBox {
  display flex
}
.disflexbtw {
  display flex
  justify-content space-between
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

